import Snackbar from "./Snackbar.vue";

export const SnackbarPlugin = {
  install(Vue) {
    const SnackbarConstructor = Vue.extend(Snackbar);
    const snackbarInstance = new SnackbarConstructor();

    // Create a div to hold the snackbar
    const mountPoint = document.createElement("div");
    document.body.appendChild(mountPoint);

    // Mount the Snackbar component to the div
    snackbarInstance.$mount(mountPoint);

    // Add snackbar instance to Vue's global properties
    Vue.prototype.$snackbar = {
      showSnackbar: (msg, color = "#333") => {
        snackbarInstance.message = msg;
        snackbarInstance.color = color; // Set color dynamically
        snackbarInstance.visible = true;
        setTimeout(() => {
          snackbarInstance.visible = false;
        }, 5000); // Hide snackbar after 5 seconds
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/snackbar/snackbar.js